import { render } from "./Promotions.vue?vue&type=template&id=76dc31f8&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"

import "./Promotions.vue?vue&type=style&index=0&id=76dc31f8&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Desktop/SILA/Web/phone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dc31f8"]])

export default __exports__